import { StyleForm } from './styles';

export const Form = ({ children, onSubmit }) => <StyleForm onSubmit={onSubmit}>{children}</StyleForm>;
